define('constants/liveReceptionistScriptTransferSelectionTypeConstants',[], function() {
    return {
        Unknown: "0",
        All: "1",
        Manual: "2"
    };
});
